
<div><div class="close-icon" mat-button (click)="dialogRef.close()" ></div>
<div>
  <h2 mat-dialog-title style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Select Policy</h2>
  <mat-dialog-content style="height: 530px;">
    <p-table [value]="policies"
             [rows]="100"
             [paginator]="true"
             [pageLinks]="3"
             [rowsPerPageOptions]="[10, 20, 50, 100]"
             [style]="{'margin-top':'10px'}"
             [resizableColumns]="true"
             [reorderableColumns]="true"
             dataKey="id"
             #dashboardTable>

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 5em;"></th>
          <th>
            Name</th><th *ngIf="controlItemId">Recommended Sections</th><th style="width: 5em"></th></tr>

      </ng-template>
      <ng-template pTemplate="expandedrow" let-rowData>
        <tr><td [attr.colspan]="controlItemId ? 3 : 2" (click)="selectPolicy(rowData)">
          <div *ngFor="let policySection of rowData.policySections">
            <h4>{{policySection.title}}</h4>
            <div [innerHTML]="policySection.text | sanitizeHtml"></div>
          </div>
        </td></tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
        <tr [pRowToggler]="rowData">
          <td>
            <a>
              <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
            </a>
          </td>
          <td>
            {{rowData.name}}
          </td>
          <td *ngIf="controlItemId">
            <ng-container *ngFor="let section of rowData.popupControlMap">
              <div>&gt; {{section.number}}{{section.subNumber ? ' .' + section.subNumber : ''}} {{section.title}} {{section.subTitle}}</div>
            </ng-container>
            <div *ngIf="rowData.isMapped">&gt; Entire Policy</div>
          </td>
          <td>
            <i class="pi pi-plus" (click)="selectPolicy(rowData)"></i>
          </td>
        </tr>
      </ng-template>



    </p-table>
  </mat-dialog-content>
</div>
</div>
